class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

/* Vesnia: het hoofdmenu klapt op desktop open zodra je erover hovert. Dawn gebruikt
   <details> en opent standaard pas bij een klik. Onder 990px niets doen, daar toont
   het thema de mobiele lade en zou hover-gedrag de lade in de weg zitten. */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const openen = (details) => {
    details.setAttribute('open', '');
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
  };
  const sluiten = (details) => {
    details.removeAttribute('open');
    details.querySelector('summary').setAttribute('aria-expanded', 'false');
  };
  document.querySelectorAll('header-menu').forEach((menu) => {
    const details = menu.querySelector('details');
    if (!details || !details.querySelector('summary')) return;
    let timer;
    menu.addEventListener('mouseenter', () => {
      if (!desktop.matches) return;
      clearTimeout(timer);
      openen(details);
    });
    menu.addEventListener('mouseleave', () => {
      if (!desktop.matches) return;
      // kleine vertraging, anders klapt het menu dicht als de muis er net langs schiet
      timer = setTimeout(() => sluiten(details), 150);
    });
  });
})();

/* Vesnia: in de mobiele lade staat het collectie-submenu meteen open, zodat direct te
   zien is dat er collecties onder Odziez damska hangen. Dawn laat het standaard dicht
   en schuift het als paneel open; de bijbehorende CSS maakt er een accordeon van. */
(() => {
  const uitklappen = () => {
    document.querySelectorAll('.menu-drawer__navigation details').forEach((d) => {
      if (!d.querySelector('.menu-drawer__submenu')) return;
      d.setAttribute('open', '');
      d.classList.add('menu-opening');
      const s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'true');
    });
  };
  uitklappen();
  document.addEventListener('DOMContentLoaded', uitklappen);
  // Dawn sluit submenu's als de lade dichtgaat, dus na het openen opnieuw uitklappen.
  document.addEventListener('click', (e) => {
    if (e.target.closest('.header__icon--menu, header-drawer summary, .menu-drawer-container > summary')) setTimeout(uitklappen, 60);
  });
})();

/* Vesnia: de volgende pagina alvast ophalen zodra de klant er met de muis overheen gaat of
   hem aanraakt. De browser begint anders pas te laden bij de klik, en dat is precies wat
   doorklikken naar een andere productpagina traag laat voelen.
   - alleen eigen links, geen cart/account/checkout (die mag je niet vooruit ophalen)
   - een link wordt hoogstens een keer opgehaald
   - niets doen op een trage of gelimiteerde verbinding */
(() => {
  const verbinding = navigator.connection || {};
  if (verbinding.saveData) return;
  if (/2g/.test(verbinding.effectiveType || '')) return;

  const gedaan = new Set();
  // LET OP: ?variant= NIET uitsluiten. Productkaarten op collectiepagina's linken juist met
  // ?variant=..., dus dat uitsluiten zette de prefetch uit op precies de belangrijkste links.
  const overslaan = /\/(cart|checkout|account|challenge|apps|search)\b/;

  const haalOp = (url) => {
    if (!url || gedaan.has(url)) return;
    gedaan.add(url);
    const l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  };

  const uitEvent = (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (a.origin !== location.origin) return;
    if (overslaan.test(a.pathname + a.search)) return;
    if (a.href === location.href) return;
    haalOp(a.href);
  };

  // mouseover voor desktop, touchstart voor mobiel (daar wint het ~100ms voor de tap)
  document.addEventListener('mouseover', uitEvent, { passive: true, capture: true });
  document.addEventListener('touchstart', uitEvent, { passive: true, capture: true });
})();
